import getProductionName from 'components/Production/utils/getProductionName';
import UIGallery from 'components/UI/Gallery/Gallery';
import { truncate } from 'lodash';
import {
  PlacementProps,
  RenderLabelProps,
  ShouldRenderType,
} from 'components/Placement/types';
import Header from '../Header/Header';

type FirstColumnProps = {
  cbn: string;
  showHeaderAndFooter: boolean | null;
  placement: PlacementProps;
  shouldRender: ShouldRenderType;
  renderLabel?: RenderLabelProps;
  search?: string | null;
  showGalleryThumbs?: boolean | null;
};
export function FirstColumn({
  cbn,
  showHeaderAndFooter = false,
  placement,
  shouldRender,
  renderLabel = (field, defaultLabel) => defaultLabel,
  search,
  showGalleryThumbs = true,
}: Readonly<FirstColumnProps>) {
  const {
    integration,
    description,
    id,
    media,
    permissions,
    source,
    title,
  } = placement;

  const {
    channel,
    networks,
    property,
    seasonOrSpecificName,
    type: productionType,
    vehiclePower,
  } = source?.production || integration?.production || {};

  return (
    <div className={`${cbn}__first`}>
      {showHeaderAndFooter && (
        <Header
          channel={channel}
          networks={networks}
          vehiclePower={vehiclePower}
          productionName={getProductionName(
            productionType,
            seasonOrSpecificName,
          )}
          seasonOrSpecificName={seasonOrSpecificName}
          propertyName={property?.name}
          sourceName={source?.name}
          releaseDate={source?.releaseDate}
          sourceNumber={source?.number}
          permissions={permissions}
          shouldRender={shouldRender}
          renderLabel={renderLabel}
          type={productionType}
          id={id.toString()}
          search={search}
        />
      )}

      {shouldRender('gallerySection.gallery') && (
        <div className={`${cbn}__gallery`}>
          <UIGallery
            files={media}
            hasMask
            showThumbs={showGalleryThumbs}
            nonPlayable={!showGalleryThumbs}
            resourceId={id}
            resourceType="placement"
            download={false}
            className={null}
            fallbackImage=""
            imageComponent={undefined}
            selectedIndex={null}
            setSelectedIndex={null}
            videoComponent={undefined}
          />
        </div>
      )}

      <div className={`${cbn}__placement-description`}>
        {shouldRender('placementTitleSection.placementTitle') && (
          <div className={`${cbn}__placement-title`}>{title}</div>
        )}
        {shouldRender('descriptionSection.description') && (
          <div className={`${cbn}__description`}>
            {truncate(description, { length: 200, separator: ' ' })}
          </div>
        )}
      </div>
    </div>
  );
}
